/*@flow*/
import irreducible from './irreducible';
import isNumber from './isNumber';

export default () => irreducible('Number', isNumber);
